
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 3.393l-1.06-1.06a1.336 1.336 0 00-1.887 0l-5.92 5.92c-.26.26-.68.26-.94 0l-1.92-1.92a1.336 1.336 0 00-1.886 0l-1.06 1.06c-.52.52-.52 1.367 0 1.887l4.386 4.393a1.322 1.322 0 001.88 0l8.393-8.386c.52-.52.52-1.367 0-1.887l.014-.007z"}})])
          )
        }
      }
    